import translations from './translations'

translations.add('pt', {
    mainDescription: 'O seu pagamento está a ser processado',
    tokenizationDescription: 'Registo do cartão a decorrer',
    verificationDescription: 'Verificação do cartão a decorrer',
    secondaryDescription: 'Aguarde, não feche nem atualize a página'
})
